import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { PasswordAuthGate } from './pages/LoginPage/PasswordAuthGate';

function NoAuthRoute({ component: Component, passwordOnly = false, ...rest }) {
  const authToken = localStorage.getItem('accessToken');
  const { pathname } = useLocation();

  return (
    <Route
      {...rest}
      render={props =>
        !authToken || pathname === '/auth/sign-up' || pathname === '/auth/reset-password' ? (
          passwordOnly ? (
            <PasswordAuthGate>
              <Component {...props} />
            </PasswordAuthGate>
          ) : (
            <Component {...props} />
          )
        ) : (
          <Redirect to={{ pathname: '/home', state: { referer: props.location } }} />
        )
      }
    />
  );
}

export default NoAuthRoute;
